import React from "react";
import "./Services.css";
import { Helmet } from "react-helmet";

const Services = () => {
  const handleClick = () => {
    alert("Button clicked!");
  };

  return (
    <>
        <Helmet>
          <title>RP SMART ENERGY - Services</title>
          <meta
            name="description"
            content="Get affordable rooftop solar installation and maintenance services across India. Save on electricity bills and enjoy eco-friendly power—book your free site consultation now!"
          />
          <meta name="keywords" content="rooftop solar installation, solar maintenance services, affordable solar, eco-friendly power, save electricity bills, free site consultation, solar services in India, RP Smart Solar, Smart Energy, solar EPC, solar solutions" />
        </Helmet>
    <div>
      <header>
        <h1>
          Powering Your World with <b style={{ fontFamily: "'Bebas', sans-serif", color:'blue'}}>RP Smart Energy</b>
        </h1>
      </header>

      <div className="container">
        <h2>About Our Services</h2>
        <section>
          
          <p style={{fontSize:25}}>
            At <strong>RP SMART ENERGY</strong>, we deliver end-to-end solar
            power and energy solutions that are reliable, efficient, and
            tailored to meet the needs of domestic, commercial, agricultural,
            and industrial customers.
          </p>
        </section>

        <section className="why-choose">
          <h2>Why Choose Us?</h2>
          <ul>
            <li>Expert Consultation – We understand your needs first</li>
            <li>Quality Products – Partnered with trusted brands</li>
            <li>Professional Installation – Certified technicians</li>
            <li>After-Sales Service – Reliable maintenance & repairs</li>
            <li>Value for Money – Solutions that pay for themselves</li>
          </ul>
        </section>

        <section>
          <h2>Our Services</h2>
          <div className="service-grid">
            {[
              {
                img: "/images/sr-solar-plant.jpg",
                alt: "Solar Power Plant",
                title: "Solar Power Plant Solutions",
                desc: "Domestic, commercial, and agricultural systems with custom setups.",
              },
              {
                img: "/images/sr-water-heater.jpg",
                alt: "Solar Water Heater",
                title: "Solar Water Heaters",
                desc: "FPC and ETC models for efficient water heating.",
              },
              {
                img: "/images/sr-solar-lighting.jpg",
                alt: "Solar Lighting Systems",
                title: "Solar Lighting Systems",
                desc: "Street lights, garden lights, wall-mount lights, and DC LED lights.",
              },
              {
                img: "/images/sr-inverters.png",
                alt: "Solar Inverters",
                title: "Solar Inverters & UPS",
                desc: "On-grid, off-grid, and hybrid inverters plus UPS systems.",
              },
              {
                img: "/images/sr-batteries.png",
                alt: "Batteries",
                title: "Batteries & Energy Storage",
                desc: "Domestic, industrial, automotive, EV, and lithium-ion batteries.",
              },
              {
                img: "/images/sr-energy-appliances.jpg",
                alt: "Solar & Energy Appliances",
                title: "Solar & Energy Appliances",
                desc: "Fans, refrigerators, cameras, and solar home kits.",
              },
              {
                img: "/images/sr-solar-fencing.jpg",
                alt: "Solar Fencing",
                title: "Solar Fencing Systems",
                desc: "Agricultural and industrial solar-powered fencing solutions.",
              },
              {
                img: "/images/sr-solar-structure.png",
                alt: "Solar Panel Structures",
                title: "Solar Panel Structures & Mounting",
                desc: "Aluminium, GI structures, and custom metal frames.",
              },
              {
                img: "/images/sr-water-purification.jpg",
                alt: "Water Purification Systems",
                title: "Water Purification Systems",
                desc: "RO purifiers and water softeners for homes and businesses.",
              },
              
            ].map((service, index) => (
              <div key={index} className="service-card">
                <img src={service.img} alt={service.alt} />
                <div className="content">
                  <h3>{service.title}</h3>
                  <p>{service.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>

      <div className="cta">
        <h2>Let’s Power Your Future</h2>
        <p>Your journey to clean, cost-effective, uninterrupted power starts here.</p>
        <button onClick={handleClick}>Click Me</button>
        <a href="https://api.whatsapp.com/send?phone=%2B919994356072&context=ARBx8knoM6sqjglkvw4k38EwfT4RJO13Uq5PJ0ufOmtXcRKpKDoHGgeBEf-GHiorSd1NGkaLhBK0Udg8J0IjnMCUGO-8lARpFJVxR0Nw2LKxIW623GQoGAXVk4-3j9VXoqf_ahm6MOD_eVevhsem90pGdA&source=FB_Page&app=facebook&entry_point=page_cta&fbclid=IwZXh0bgNhZW0CMTAAAR11hDssT-PjKeexIv-HKS52O7DvS9Lyv68vtvXAFCHIebcQVPFzfLD3k3c_aem_qf47WVPi5jksNnR9Hj-A3A">📞 Call / WhatsApp</a>
        <a href="https://mail.google.com/mail/u/0/#inbox?compose=DmwnWrRrkqgxCgrXPRdWZtNbZRHhhdxVQjZJnlZnTNPWgNSQPLRLWSmNxDQKgvBvdFPBhHtQVzJl">✉ Email Us</a>
      </div>
    </div>
    </>
  );
};

export default Services;